export default __webpack_public_path__ + "static/media/privacy.26d7a3e1.svg";